import {
  getAboutTeamPointsTooltip,
  getAboutPersonPointsTooltip,
  getGetMorePointsCustomerConfig,
  getContactUsCustomerConfig,
  getSpaceExpiredReminderCustomerConfig,
} from '@/constants/tip-config';
import { i18n } from '@/i18n';

// 配置 map 管理不同状态下的文案和行为
export const SPACE_CONFIG_MAP = {
  person: {
    displayName: () => i18n.t('components:points.personalEdition'),
    buttonText: () => i18n.t('common:upgrade'),
    modalConfig: () => getGetMorePointsCustomerConfig(),
  },
  team: {
    displayName: () => i18n.t('components:points.teamEdition'),
    buttonText: () => i18n.t('common:recharge'),
    modalConfig: () => getContactUsCustomerConfig(),
  },
  'team-block': {
    displayName: () => i18n.t('components:points.teamEdition'),
    buttonText: () => i18n.t('common:renewNow'),
    modalConfig: () => getSpaceExpiredReminderCustomerConfig(),
  },
} as const;

export const tooltipConfigMap = {
  person_points: () => getAboutPersonPointsTooltip(),
  team_points: () => getAboutTeamPointsTooltip(),
} as const;

export type SpaceConfigKey = keyof typeof SPACE_CONFIG_MAP;
export type SpaceConfig = (typeof SPACE_CONFIG_MAP)[SpaceConfigKey];
export type TooltipConfigKey = keyof typeof tooltipConfigMap;

/**
 * 根据空间类型和状态获取对应的配置
 * @param spaceType - 空间类型
 * @param status - 空间状态
 * @returns 对应的配置对象
 */
export function getSpaceConfig(
  spaceType?: string,
  status?: string,
): SpaceConfig {
  if (spaceType === 'person') {
    return SPACE_CONFIG_MAP.person;
  }

  // 根据具体的 status 返回对应配置
  switch (status) {
    case 'active':
    case 'depleted':
      return SPACE_CONFIG_MAP.team;
    case 'block':
      return SPACE_CONFIG_MAP['team-block'];
    default:
      // 默认使用 team 配置
      return SPACE_CONFIG_MAP.team;
  }
}

/**
 * 根据空间类型和状态获取 PointsTag 的类型
 * @param spaceType - 空间类型
 * @param status - 空间状态
 * @returns PointsTag 的类型字符串
 */
export function getPointsTagType(
  spaceType?: string,
  status?: string,
): 'personal' | 'team-active' | 'team-block' {
  if (spaceType === 'person') {
    return 'personal';
  }

  // 根据具体的 status 返回对应的样式类型
  switch (status) {
    case 'active':
    case 'depleted':
      return 'team-active';
    case 'block':
      return 'team-block';
    default:
      return 'team-active';
  }
}

/**
 * 获取 Tooltip 配置
 * @param type - 积分类型
 * @returns Tooltip 配置对象或 null
 */
export function getTooltipConfig(type: string) {
  if (type === 'day_grant') return null;

  const configFn = tooltipConfigMap[type as TooltipConfigKey];
  if (!configFn) return null;

  return configFn();
}
